export const TEST_ID = 'equipmentRowActions';

export const MENU_TEST_ID = 'equipmentRowActionsMenu';

export const MENU_OFFSET_PIXELS = 4;

export const ESTIMATED_MENU_HEIGHT_PIXELS = 88;

export const ESCAPE_KEY = 'Escape';
